import "bootstrap/dist/css/bootstrap.min.css";
import 'assets/sass/app.scss'
import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './services/core/api/client'
import { ConfigProvider } from "antd";

/**
 * Main application initialization function
 * This is the entry point of the application
 */
async function main() {
    console.log('Starting application initialization...');
    console.log('Environment:', process.env.NODE_ENV);
    
    // Enable MSW based on environment variable
    const enableMsw = process.env.REACT_APP_ENABLE_MSW === 'true';
    console.log('MSW enabled:', enableMsw);
    
    // Initialize MSW if enabled and in development mode
    if (process.env.NODE_ENV === 'development' && enableMsw) {
        try {
            console.log('Initializing MSW...');
            const { initializeMsw } = await import('./mocks');
            await initializeMsw({
                enabled: true,
                debug: true // Enable MSW debug logging
            });
            console.log('✅ Mock Service Worker initialized successfully');
        } catch (error) {
            console.error('❌ Failed to initialize Mock Service Worker:', error);
        }
    } else {
        console.log('MSW initialization skipped (disabled in configuration)');
    }

    // Get the root element for React rendering
    const rootElement = document.getElementById('root');

    if (!rootElement) {
        throw new Error("找不到 #root 元素");
    }
    
    // Initialize React
    const root = createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <ConfigProvider
                theme={{
                    token: {
                        colorTextDisabled: 'rgba(0, 0, 0, 0.65)',
                        colorBgContainerDisabled: '#f5f7fa',
                    },
                    components: {
                        Input: {
                            colorTextDisabled: 'rgba(0, 0, 0, 0.65)',
                            colorBgContainerDisabled: '#f5f7fa',
                        },
                        Select: {
                            colorTextDisabled: 'rgba(0, 0, 0, 0.65)',
                            colorBgContainerDisabled: '#f5f7fa',
                        },
                        DatePicker: {
                            colorTextDisabled: 'rgba(0, 0, 0, 0.65)',
                            colorBgContainerDisabled: '#f5f7fa',
                        },
                        InputNumber: {
                            colorTextDisabled: 'rgba(0, 0, 0, 0.65)',
                            colorBgContainerDisabled: '#f5f7fa',
                        },
                    },
                }}
            >
                {/*<Provider store={store}>*/}
                <App />
                {/*</Provider>*/}
            </ConfigProvider>
        </React.StrictMode>
    );
    
    console.log('Application initialized');
}

// Start the application
main().catch(error => {
    console.error('❌ Application initialization failed:', error);
});